import COLORS from './colors';

const checkbox = {
  styleOverrides: {
    root: {
      '& input + svg': {
        color: '#D9D1E0'
      },
      '& input:checked + svg': {
        color: COLORS.accent
      },
      '& input:disabled + svg': {
        color: COLORS.gray
      }
    }
  }
};

export default checkbox;
